export default class ItemProviders {

}
ItemProviders.RARITY_COMMON = "common";
ItemProviders.RARITY_UNCOMMON = "uncommon";
ItemProviders.RARITY_RARE = "rare";
ItemProviders.RARITY_EPIC = "epic";
ItemProviders.RARITY_LEGENDARY = "legendary";
ItemProviders.RARITY_UNIQUE = "unique";

ItemProviders.TYPE_NONE = "none"
ItemProviders.TYPE_ARMOUR_ARMOURS = "armour_armours"
ItemProviders.TYPE_ARMOUR_ARMS = "armour_arms"
ItemProviders.TYPE_ARMOUR_HELMS = "armour_helms"
ItemProviders.TYPE_ARMOUR_LEGGINGS = "armour_leggings"
ItemProviders.TYPE_ARMOUR_SHIELDS = "armour_shields"
ItemProviders.TYPE_ARMOUR_SHOES = "armour_shoes"


ItemProviders.TYPE_BOOKS = "books"
ItemProviders.TYPE_INGOTS = "ingots"
ItemProviders.TYPE_MONEYS = "moneys"
ItemProviders.TYPE_KEYS = "keys"
ItemProviders.TYPE_LOGS = "logs"
ItemProviders.TYPE_TOOLS = "tools"

ItemProviders.TYPE_CONSUMABLES_FOOD = "consumables_food"
ItemProviders.TYPE_CONSUMABLES_POTIONS = "consumables_potions"

ItemProviders.TYPE_JEWEL_NECKLACES = "jewel_necklaces"
ItemProviders.TYPE_JEWEL_RINGS = "jewel_rings"

ItemProviders.TYPE_WEAPON_AXES = "weapon_axes"
ItemProviders.TYPE_WEAPON_HAMMERS = "weapon_hammers"
ItemProviders.TYPE_WEAPON_MACES = "weapon_maces"
ItemProviders.TYPE_WEAPON_SPEARS = "weapon_spears"
ItemProviders.TYPE_WEAPON_SWORDS = "weapon_swords"

ItemProviders.WEAPON_SKILL_NONE = "none";
ItemProviders.WEAPON_SKILL_SWORDSMANSHIP = "Swordsmanship"
ItemProviders.WEAPON_SKILL_MACECOMBAT = "MaceCombat"
ItemProviders.WEAPON_SKILL_FENCING = "Fencing"

ItemProviders.ARMOUR_CLASS_NONE = "none";
ItemProviders.ARMOUR_CLASS_LIGHT = "light";
ItemProviders.ARMOUR_CLASS_MEDIUM = "medium";
ItemProviders.ARMOUR_CLASS_HEAVY = "heavy";


ItemProviders.MATERIAL_NA = "n/a";
ItemProviders.MATERIAL_FOOD = "food";
ItemProviders.MATERIAL_WOOD = "wood";
ItemProviders.MATERIAL_CLOTH = "cloth";
ItemProviders.MATERIAL_LEATHER = "leather";
ItemProviders.MATERIAL_IRON = "iron";
ItemProviders.MATERIAL_COPPER = "copper";
ItemProviders.MATERIAL_SHADOW = "shadow";
ItemProviders.MATERIAL_BRONZE = "bronze";
ItemProviders.MATERIAL_SILVER = "silver";
ItemProviders.MATERIAL_GOLD = "gold";
ItemProviders.MATERIAL_VERITE = "verite";
ItemProviders.MATERIAL_VALORITE = "valorite";
ItemProviders.MATERIAL_CRYSTITE = "crystite";


ItemProviders.PLAYER_SKILL_NONE = "none";
ItemProviders.PLAYER_SKILL_ALCHEMY = "Alchemy";
ItemProviders.PLAYER_SKILL_ARMOURPROFICIENCY = "ArmourProficiency";
ItemProviders.PLAYER_SKILL_ARMSLORE = "ArmsLore";
ItemProviders.PLAYER_SKILL_CAMPING = "Camping";
ItemProviders.PLAYER_SKILL_COOKING = "Cooking";
ItemProviders.PLAYER_SKILL_FENCING = "Fencing";
ItemProviders.PLAYER_SKILL_FISHING = "Fishing";
ItemProviders.PLAYER_SKILL_LUMBERJACK = "Lumberjack";
ItemProviders.PLAYER_SKILL_MACECOMBAT = "MaceCombat";
ItemProviders.PLAYER_SKILL_MINING = "Mining";
ItemProviders.PLAYER_SKILL_PARRYING = "Parrying";
ItemProviders.PLAYER_SKILL_REMOVETRAP = "RemoveTrap";
ItemProviders.PLAYER_SKILL_SWORDSMANSHIP = "Swordsmanship";
ItemProviders.PLAYER_SKILL_TACTICS = "Tactics";


ItemProviders.DEFAULTS = [
	{
		types: [
			ItemProviders.TYPE_ARMOUR_ARMOURS,
			ItemProviders.TYPE_ARMOUR_LEGGINGS,
		],
		stats: {
			material: ItemProviders.MATERIAL_LEATHER,
			armour_class: ItemProviders.ARMOUR_CLASS_LIGHT,
			wearable: true,
			armour: true,
			defense: 2,
			gold: 200
		}
	},
	{
		types: [
			ItemProviders.TYPE_ARMOUR_ARMS,
			ItemProviders.TYPE_ARMOUR_HELMS,
			ItemProviders.TYPE_ARMOUR_SHOES,
		],
		stats: {
			material: ItemProviders.MATERIAL_LEATHER,
			armour_class: ItemProviders.ARMOUR_CLASS_LIGHT,
			wearable: true,
			armour: true,
			defense: 1,
			gold: 100
		}
	},
	{
		types: [
			ItemProviders.TYPE_ARMOUR_SHIELDS,
		],
		stats: {
			material: ItemProviders.MATERIAL_WOOD,
			armour_class: ItemProviders.ARMOUR_CLASS_LIGHT,
			wearable: true,
			armour: true,
			defense: 3,
			gold: 300
		}
	},
	{
		types: [
			ItemProviders.TYPE_CONSUMABLES_FOOD,
		],
		stats: {
			material: ItemProviders.MATERIAL_NA,
			consumable: true,
			cookable: false,
			cookskill: 0,
			cooktransform: "",
			edible: true,
			food: 10,
			heal: 1,
			gold: 50
		}
	},
	{
		types: [
			ItemProviders.TYPE_CONSUMABLES_POTIONS,
		],
		stats: {
			material: ItemProviders.MATERIAL_NA,
			consumable: true,
			drinkable: true,
			heal: 50,
			water: 10,
			gold: 200,
			stackable: true
		}
	},
	{
		types: [
			ItemProviders.TYPE_JEWEL_NECKLACES,
			ItemProviders.TYPE_JEWEL_RINGS,
		],
		stats: {
			material: ItemProviders.MATERIAL_GOLD,
			wearable: true,
			gold: 500
		}
	},
	{
		types: [
			ItemProviders.TYPE_MONEYS
		],
		stats: {
			material: ItemProviders.MATERIAL_GOLD,
			gold: 1,
			stackable: true
		}
	},
	{
		types: [
			ItemProviders.TYPE_WEAPON_AXES,
			ItemProviders.TYPE_WEAPON_SWORDS,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			weapon_skill: ItemProviders.WEAPON_SKILL_SWORDSMANSHIP,
			wearable: true,
			weapon: true,
			attack_min: 12,
			attack_max: 16,
			speed: 1,
			gold: 100
		}
	},
	{
		types: [
			ItemProviders.TYPE_WEAPON_HAMMERS,
			ItemProviders.TYPE_WEAPON_MACES,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			weapon_skill: ItemProviders.WEAPON_SKILL_MACECOMBAT,
			wearable: true,
			weapon: true,
			attack_min: 12,
			attack_max: 16,
			speed: 1,
			gold: 100
		}
	},
	{
		types: [
			ItemProviders.TYPE_WEAPON_SPEARS,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			weapon_skill: ItemProviders.WEAPON_SKILL_FENCING,
			wearable: true,
			weapon: true,
			attack_min: 12,
			attack_max: 16,
			speed: 1,
			gold: 100
		}
	},
	{
		types: [
			ItemProviders.TYPE_BOOKS,
		],
		stats: {
			material: ItemProviders.MATERIAL_NA,
			consumable: true,
			gold: 100
		}
	},
	{
		types: [
			ItemProviders.TYPE_INGOTS,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			gold: 1,
			stackable: true 
		}
	},
	{
		types: [
			ItemProviders.TYPE_KEYS,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			gold: 10,
			stackable: true
		}
	},
	{
		types: [
			ItemProviders.TYPE_LOGS,
		],
		stats: {
			material: ItemProviders.MATERIAL_WOOD,
			gold: 1,
			stackable: true
		}
	},
	{
		types: [
			ItemProviders.TYPE_TOOLS,
		],
		stats: {
			material: ItemProviders.MATERIAL_IRON,
			gold: 100
		}
	},
]

ItemProviders.SHOWN = [
	{
		types: [
			ItemProviders.TYPE_WEAPON_AXES,
			ItemProviders.TYPE_WEAPON_HAMMERS,
			ItemProviders.TYPE_WEAPON_MACES,
			ItemProviders.TYPE_WEAPON_SPEARS,
			ItemProviders.TYPE_WEAPON_SWORDS
		],

		props: ["id", "name", "group", "description", "level", "type", "rarity", "material", "weapon_skill", "skill_needed","attack_min", "attack_max", "speed", "bonus_skill", "player_skill", "gold", "weight", "startItem", "worn"],
		showAs: "weapon"
	},
	{
		types: [
			ItemProviders.TYPE_ARMOUR_ARMOURS,
			ItemProviders.TYPE_ARMOUR_LEGGINGS,
			ItemProviders.TYPE_ARMOUR_ARMS,
			ItemProviders.TYPE_ARMOUR_HELMS,
			ItemProviders.TYPE_ARMOUR_SHOES,
			ItemProviders.TYPE_ARMOUR_SHIELDS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "armour_class", "defense", "speed", "bonus_skill", "player_skill", "gold", "weight", "startItem", "worn"],
		showAs: "armour"
	},
	{
		types: [
			ItemProviders.TYPE_JEWEL_NECKLACES,
			ItemProviders.TYPE_JEWEL_RINGS,
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "bonus_defense", "bonus_damage", "bonus_speed", "bonus_skill", "player_skill", "gold", "weight", "startItem", "worn", "startQuantity"],
		showAs: "jewel"
	},
	{
		types: [
			ItemProviders.TYPE_MONEYS,
		],
		props: ["id", "name", "group","description", "type", "stacked", "startItem"],
		showAs: "money"
	},
	{
		types: [
			ItemProviders.TYPE_CONSUMABLES_FOOD,
		],
		props: ["id", "name", "group", "description", "type", "edible", "cookable", "cookskill","cooktransform","food", "drinkable", "water", "heal", "weight","stackable", "startItem","startQuantity"],
		showAs: "food"
	},
	{
		types: [
			ItemProviders.TYPE_CONSUMABLES_POTIONS,
		],
		props: ["id", "name", "group", "description", "type", "water", "heal", "stackable", "weight", "startItem", "startQuantity"],
		showAs: "potion"
	},
	{
		types: [
			ItemProviders.TYPE_BOOKS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "bonus_defense", "bonus_damage", "bonus_speed", "bonus_skill", "player_skill", "gold", "weight", "startItem", "startQuantity"],
		showAs: "book"
	},
	{
		types: [
			ItemProviders.TYPE_INGOTS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "stacked", "gold", "weight", "startItem", "startQuantity"],
		showAs: "resource"
	},
	{
		types: [
			ItemProviders.TYPE_KEYS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "stackable", "gold", "weight", "startItem", "startQuantity"],
		showAs: "key"
	},
	{
		types: [
			ItemProviders.TYPE_LOGS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "stacked", "gold", "weight", "startItem", "startQuantity"],
		showAs: "resource"
	},
	{
		types: [
			ItemProviders.TYPE_TOOLS
		],
		props: ["id", "name", "group","description", "level", "type", "rarity", "material", "gold", "weight", "startItem", "startQuantity"],
		showAs: "tool"
	},

]

ItemProviders.ITEM_TYPE_DESCRIPTIONS = [
	{ type: ItemProviders.TYPE_ARMOUR_ARMOURS, value: "Armour" },
	{ type: ItemProviders.TYPE_ARMOUR_ARMS, value: "Arms" },
	{ type: ItemProviders.TYPE_ARMOUR_HELMS, value: "Helm" },
	{ type: ItemProviders.TYPE_ARMOUR_LEGGINGS, value: "Leggings" },
	{ type: ItemProviders.TYPE_ARMOUR_SHIELDS, value: "Shield" },
	{ type: ItemProviders.TYPE_ARMOUR_SHOES, value: "Shoes" },
	{ type: ItemProviders.TYPE_BOOKS, value: "Book" },
	{ type: ItemProviders.TYPE_INGOTS, value: "Resource" },
	{ type: ItemProviders.TYPE_MONEYS, value: "Gold" },
	{ type: ItemProviders.TYPE_KEYS, value: "Key" },
	{ type: ItemProviders.TYPE_LOGS, value: "Resource" },
	{ type: ItemProviders.TYPE_TOOLS, value: "Tool" },
	{ type: ItemProviders.TYPE_CONSUMABLES_FOOD, value: "Food/Water" },
	{ type: ItemProviders.TYPE_CONSUMABLES_POTIONS, value: "Potion" },
	{ type: ItemProviders.TYPE_JEWEL_NECKLACES, value: "Nekclace" },
	{ type: ItemProviders.TYPE_JEWEL_RINGS, value: "Ring" },
	{ type: ItemProviders.TYPE_WEAPON_AXES, value: "Axe" },
	{ type: ItemProviders.TYPE_WEAPON_HAMMERS, value: "Hammer" },
	{ type: ItemProviders.TYPE_WEAPON_MACES, value: "Mace" },
	{ type: ItemProviders.TYPE_WEAPON_SPEARS, value: "Spear" },
	{ type: ItemProviders.TYPE_WEAPON_SWORDS, value: "Sword" },
]

ItemProviders.ITEM_RARITY_DESCRIPTIONS = [
	{ rarity: ItemProviders.RARITY_COMMON, value: "Common" },
	{ rarity: ItemProviders.RARITY_UNCOMMON, value: "Uncommon" },
	{ rarity: ItemProviders.RARITY_RARE, value: "Rare" },
	{ rarity: ItemProviders.RARITY_EPIC, value: "Epic" },
	{ rarity: ItemProviders.RARITY_LEGENDARY, value: "Legendary" },
	{ rarity: ItemProviders.RARITY_UNIQUE, value: "Unique" },
];

ItemProviders.ITEM_ARMOUR_CLASS_DESCRIPTIONS = [
	{ armour_class: ItemProviders.ARMOUR_CLASS_NONE, value: "None" },
	{ armour_class: ItemProviders.ARMOUR_CLASS_LIGHT, value: "Light armour" },
	{ armour_class: ItemProviders.ARMOUR_CLASS_MEDIUM, value: "Medium armour" },
	{ armour_class: ItemProviders.ARMOUR_CLASS_HEAVY, value: "Heavy armour" },
];

ItemProviders.ITEM_MATERIAL_DESCRIPTIONS = [
	{ material: ItemProviders.MATERIAL_NA, value: "N/A" },
	{ material: ItemProviders.MATERIAL_FOOD, value: "Food" },
	{ material: ItemProviders.MATERIAL_WOOD, value: "Wood" },
	{ material: ItemProviders.MATERIAL_CLOTH, value: "Cloth" },
	{ material: ItemProviders.MATERIAL_LEATHER, value: "Leather" },
	{ material: ItemProviders.MATERIAL_IRON, value: "Iron" },
	{ material: ItemProviders.MATERIAL_COPPER, value: "Copper" },
	{ material: ItemProviders.MATERIAL_SHADOW, value: "Shadow iron" },
	{ material: ItemProviders.MATERIAL_BRONZE, value: "Bronze" },
	{ material: ItemProviders.MATERIAL_SILVER, value: "Silver" },
	{ material: ItemProviders.MATERIAL_GOLD, value: "Gold" },
	{ material: ItemProviders.MATERIAL_VERITE, value: "Verite" },
	{ material: ItemProviders.MATERIAL_VALORITE, value: "Valorite" },
	{ material: ItemProviders.MATERIAL_CRYSTITE, value: "Crystite" },
];


ItemProviders.SHOW_ITEM_WEAPON = "weapon";
ItemProviders.SHOW_ITEM_ARMOUR = "armour";
ItemProviders.SHOW_ITEM_JEWEL = "jewel";
ItemProviders.SHOW_ITEM_MONEY = "money";
ItemProviders.SHOW_ITEM_FOOD = "food";
ItemProviders.SHOW_ITEM_POTION = "potion";
ItemProviders.SHOW_ITEM_BOOK = "book";
ItemProviders.SHOW_ITEM_RESOURCE = "resource";
ItemProviders.SHOW_ITEM_KEY = "key";
ItemProviders.SHOW_ITEM_TOOL = "tool";

